<template>
  <BannerBlock v-if="!finished" :key="finished">
    <template v-slot:title>
      <template v-if="step <= 4">{{ $t("banner.welcome.title") }}</template>
      <template v-else>{{ $t("banner.welcome.thank") }}</template>
    </template>

    <template v-slot:message>
      <template v-if="step <= 4">{{ $t("banner.welcome.checklist.title") }}</template>
      <template v-else>{{ $t("banner.guideReviewDesc") }}</template>
    </template>

    <template v-slot:actions>
      <button class="btn btn-success" @click="nextStep">
        <template v-if="step < 1">{{ $t("banner.welcome.doIt") }}</template>
        <template v-else-if="step > 4">{{ $t("generals.close") }}</template>
        <template v-else>{{ $t("generals.continue") }}</template>
      </button>
    </template>

    <template v-slot:default>
      <div class="row ml-auto">
        <div class="col">
          <div class="verticle check-list">
            <ul class="steps typo-h5">
              <li class="step" :class="[{ active: step >= 1 }, { done: step > 1 }]">{{ $t("banner.welcome.checklist.step1") }}</li>
              <li class="step" :class="[{ active: step >= 2 }, { done: step > 2 }]">{{ $t("banner.welcome.checklist.step2") }}</li>
              <li class="step" :class="[{ active: step >= 3 }, { done: step > 3 }]">{{ $t("banner.welcome.checklist.step3") }}</li>
              <li class="step" :class="[{ active: step >= 4 }, { done: step > 4 }]">{{ $t("banner.welcome.checklist.step4") }}</li>
            </ul>
          </div>
          <div class="step-progress mt-auto">
            <div class="row">
              <div class="col-10">
                <template v-if="step - 1 < 0">0</template>
                <template v-else>{{ step - 1 }}</template>
                out of 4 steps.
              </div>
              <div class="col ml-auto">
                <template v-if="step <= 4">
                  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5781 2.90625H9.84375C9.84375 3.12195 9.84375 8.72937 9.84375 8.53125C9.84375 8.92511 9.53448 9.23438 9.14062 9.23438V9.9375H17.5781L14.9344 6.42188L17.5781 2.90625Z" fill="#85929E" />
                    <path d="M10.5469 0V8.53125H9.84375C9.84375 8.13739 9.53448 7.82812 9.14062 7.82812H6.89062C6.75 7.46246 6.55316 7.125 6.32812 7.125H2.8125L2.53125 3.75L2.8125 0H10.5469Z" fill="#CDCFD1" />
                    <path d="M9.14062 9.9375H6.32812V7.125H9.14062C9.91736 7.125 10.5469 7.75452 10.5469 8.53125C10.5469 9.30798 9.91736 9.9375 9.14062 9.9375Z" fill="#737F8A" />
                    <path d="M0 1C0 0.447715 0.447715 0 1 0H3V17H0V1Z" fill="#CDCFD1" />
                    <path d="M1 0H3V17H1V0Z" fill="#85929E" />
                  </svg>
                </template>
                <template v-else>
                  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5781 2.90625H9.84375C9.84375 3.12195 9.84375 8.72937 9.84375 8.53125C9.84375 8.92511 9.53448 9.23438 9.14062 9.23438V9.9375H17.5781L14.9344 6.42188L17.5781 2.90625Z" fill="#39AF77" />
                    <path d="M10.5469 0V8.53125H9.84375C9.84375 8.13739 9.53448 7.82812 9.14062 7.82812H6.89062C6.75 7.46246 6.55316 7.125 6.32812 7.125H2.8125L2.53125 3.75L2.8125 0H10.5469Z" fill="#42C184" />
                    <path d="M9.14062 9.9375H6.32812V7.125H9.14062C9.91736 7.125 10.5469 7.75452 10.5469 8.53125C10.5469 9.30798 9.91736 9.9375 9.14062 9.9375Z" fill="#23774F" />
                    <path d="M0 1C0 0.447715 0.447715 0 1 0H3V17H0V1Z" fill="#0E3C82" />
                    <path d="M1 0H3V17H1V0Z" fill="#072856" />
                  </svg>
                </template>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <progress class="progress-success" :value="step - 1" :max="4"></progress>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BannerBlock>

  <BannerBlock v-else :key="finished">
    <template v-slot:title>{{ $t("banner.welcome.checklist.thank") }}</template>
    <template v-slot:message>{{ $t("banner.guideTipsDesc") }}</template>
    <template v-slot:actions>
      <button class="btn btn-primary" @click="$router.replace({ name: 'Tutorials' })">{{ $t("banner.watchTuts") }}</button>
      <button class="btn btn-warning" @click="$router.replace({ name: 'Pricing' })">{{ $t("generals.upgrade") }} {{ $t("generals.now") }}</button>
    </template>
    <template v-slot:default>
      <!-- <img class="ml-auto" src="@/core/assets/Dashboard/Banner/Guide/tips.svg" /> -->
      <!-- <div class="bg ml-auto col-sm-4 d-none d-sm-unset"></div> -->
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/Guide/tips.svg')" />
      </div>
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../BannerBlock";
export default {
  name: "Welcome",
  components: {
    BannerBlock
  },
  data() {
    return {
      finished: false,
      step: 0
    };
  },
  methods: {
    nextStep() {
      if (this.step > 4) {
        this.finished = true;
        return;
      }
      this.step += 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.check-list {
  display: flex;
  &.verticle {
    flex-direction: column;
    padding-left: 25px;
    margin-bottom: 24px;
  }
  .steps {
    .step {
      list-style-type: none;
      position: relative;

      &:not(:first-of-type) {
        margin-top: 8px;
        &:before {
          content: "";
          position: absolute;
          z-index: 5;
          width: 1.25px;
          height: 100%;
          top: -19px;
          left: -26px;
          background-color: $grey3;
          @include trans-all;
        }
      }

      &:after {
        content: "";
        position: absolute;
        z-index: 10;
        $size: 14px;
        width: $size - 1;
        height: $size - 1;
        border: 1.25px solid $grey3;
        border-radius: 50%;
        left: -$size - 18;
        top: calc(50% - #{$size} / 2);
        background: #fff;
        @include trans-all;
      }

      &.active {
        &:before {
          background-color: $cGreen;
        }
        &:after {
          border-color: $cGreen;
        }
      }

      &.done {
        &:after {
          background-color: $cGreen;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6' fill='none' %3E%3Cpath d='M6.79498 0.21967C7.07065 -0.0732233 7.51759 -0.0732233 7.79325 0.21967C8.06892 0.512563 8.06892 0.987437 7.79325 1.28033L3.55796 5.78033C3.28229 6.07322 2.83535 6.07322 2.55969 5.78033L0.206748 3.28033C-0.0689161 2.98744 -0.0689161 2.51256 0.206748 2.21967C0.482412 1.92678 0.929352 1.92678 1.20502 2.21967L3.05882 4.18934L6.79498 0.21967Z' fill='%23fff'/%3E%3C/svg%3E%0A");
          background-repeat: no-repeat;
          background-position: 2px 3px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
// .bg {
//   background-image: url(~@/core/assets/Dashboard/Banner/Guide/tips.svg);
//   width: 288px;
// }
</style>
